import { defineMessages } from 'react-intl'

import { SALES_CHANNEL } from './constants'

export const salesChannelMessages = defineMessages({
  [SALES_CHANNEL.NA]: {
    id: 'salesChannel.na',
    defaultMessage: 'N/A'
  },
  [SALES_CHANNEL.OFFLINE]: {
    id: 'salesChannel.offline',
    defaultMessage: 'Offline'
  },
  [SALES_CHANNEL.ONLINE]: {
    id: 'salesChannel.online',
    defaultMessage: 'Online'
  }
})
